import {Link, useNavigate, useSearchParams} from "react-router-dom";
import Input from "../../components/Input";
import InputPassword from "../../components/InputPassword";
import {
    checkUserIsValidate, ConfirmChangePasswordCode,
    GetChangePasswordToken,
    login,
    register,
    setToken,
    states, UserChangePassword,
    UserReferencerList,
    verifyUser
} from "../../services";
import {useFormik} from "formik";
import {initialValues} from "../../utils/formsValidator/forgetPasswordFormValidator";
import {validationSchema} from "../../utils/formsValidator/forgetPasswordFormValidator";

import {initialChangePasswordValues} from "../../utils/formsValidator/changeForcePasswordFormValidator";
import {validationChangePasswordSchema} from "../../utils/formsValidator/changeForcePasswordFormValidator";

import {pushToast} from "../../utils/pushToast";
import {useEffect, useState} from "react";
import {useAuthAction} from "../../context/AuthContext";
import Loading from "../../components/Loading";
import VerifyCode from "../../components/VerifyCode";
import Modal from "../../components/Modal";
import {convertToWesternNumerals, handelPrice} from "../../utils/helper";

export default function Register() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showValidationCode, setShowValidationCode] = useState(0);
    const [mobile, setMobile] = useState(null);
    const [referencerName, setReferencerName] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const [code, setCode] = useState(null);
    const [codeToken, setCodeToken] = useState(null);

    const [userCode, setUserCode] = useState(null);

    const [isOpen,setIsOpen] = useState(false);
    const [referencerList,setReferencerList] = useState([]);


    const setAuth = useAuthAction();
    const [isValidReferencerCode, setIsValidReferencerCode] = useState(false);

    const onSubmit =async (values) => {

        setIsLoading(true);
        try {
            const {data,status,message} = await GetChangePasswordToken(convertToWesternNumerals(values.mobile));
            if (status == 200) {
                setShowValidationCode(1)
                setMobile( values.mobile)
                setCodeToken(data)
                setIsLoading(false);

            } else {
                pushToast(message, "error")
                setIsLoading(false);

            }

        } catch (ex) {
            setIsLoading(false);
            console.log(ex)
        }
    }

    const onSubmitChangePassword =async (values) => {

        const formValues = {...values,mobile:mobile,code:code,codeToken:codeToken}
        setIsLoading(true);
        try {
            const {userInfo, userPermission,message,status} = await UserChangePassword(formValues);



            if ( userInfo && userInfo.isSuccess) {
                setToken(userInfo?.data?.token)
                setAuth({userInfo: userInfo?.data, userPermission});
                navigate('/dashboard');
                setIsLoading(false);

            } else {
                pushToast(message, "error")
                setIsLoading(false);

            }

        } catch (ex) {
            setIsLoading(false);
            console.log(ex)
        }
    }

    const onConfirmChangePasswordCodeSubmit =async () => {
        const formValues = {mobile:mobile,code:code,codeToken:codeToken}
        setIsLoading(true);
        try {
            const {status,message} = await ConfirmChangePasswordCode(formValues);

            if (status==200) {
                pushToast(message, "success")
                setShowValidationCode(2)
                setIsLoading(false);


            } else {
                pushToast(message, "error")
                setIsLoading(false);

            }

        } catch (ex) {
            setIsLoading(false);
            console.log(ex)
        }
    }

    const ReferencerList =async () => {

        setIsLoading(true);
        try {
            const {data,message,status} = await UserReferencerList();

            if (status==200) {
                setReferencerList(data);
                setIsLoading(false);
            } else {
                pushToast(message, "error")
                setIsLoading(false);

            }

        } catch (ex) {
            setIsLoading(false);
            console.log(ex)
        }
    }
    const formik = useFormik({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnMount: false
    });
    const formikChangePassword = useFormik({
        initialValues:initialChangePasswordValues,
        onSubmit: onSubmitChangePassword,
        validationSchema:validationChangePasswordSchema,
        validateOnMount: false,
    });
    useEffect( () => {
        if(searchParams.get("userCode") != null){
            setUserCode(searchParams.get("userCode"))
            userIsValidate(searchParams.get("userCode"))
        }else{
            // userIsValidate(userCode)
            setUserCode(null)
        }
        ReferencerList()
    },[])
    const userIsValidate = async (value) =>{
        setIsLoading(true)
        try {
            const values = {
                referencerCode : value,
            }
            if(value !== ""){
                const {data,result,status,message} = await checkUserIsValidate(values);
                if(status === 200){
                    formik.setValues({ ...formik.values, validateReferencerCode: true ,referenceCode:convertToWesternNumerals(value) });
                    //formik.setValues({ ...formik.values, referenceCode: value });
                    setReferencerName(message)
                    setIsValidReferencerCode(true)
                    console.log(formik.values)
                }else {
                    setIsValidReferencerCode(false)
                    setReferencerName("کد معرف نامعتبر می باشد")
                    formik.setValues({ ...formik.values, validateReferencerCode: false });

                    // formik.values["validateReferencerCode"]= false
                }
            }else {
                setIsValidReferencerCode(false)
                formik.setValues({ ...formik.values, validateReferencerCode: false });

                setReferencerName("کد معرف نامعتبر می باشد")
                // formik.values["validateReferencerCode"]= false
            }

            setIsLoading(false)
        } catch (ex){
            pushToast("خطای سرور", "error");
            setReferencerName(null)
            setIsLoading(false)
        }
    }

    const handleCodeChange = (code) => {
        setCode(code)
    };
    const handelSelectReferencer =(id) =>{

        formik.setValues({ ...formik.values, referenceCode: id });
        formik.values["referenceCode"]= id

        userIsValidate(id)
        setIsOpen(false)
    };
    return (
        <>
            {showValidationCode == 0 &&
                <div className="container-xxl backgroud-image">
                    <div className="authentication-wrapper authentication-basic container-p-y">
                        <div className="authentication-inner py-4">
                            <div className="card card-border">
                                <div className="card-body">
                                    <div className="col-5 app-brand justify-content-center m-auto">
                                        {/*<img src="/logo.png" className={'w-100 '}/>*/}
                                    </div>
                                    <hr/>
                                    {/*<div className="app-brand justify-content-center">*/}
                                    {/*    <Link to="/" className="app-brand-link gap-2">*/}
                                    {/*        <span className="app-brand-text demo h3 mb-0 fw-bold">فرست</span>*/}
                                    {/*    </Link>*/}
                                    {/*</div>*/}
                                    <h4 className="mb-2 text-center">بازیابی رمز عبور</h4>
                                    {/*<p className="mb-4">مدیریت برنامه خود را آسان و جذاب کنید!</p>*/}

                                    <form id="formAuthentication"
                                          className={`needs-validation mb-3 ${!formik.isValid ? "was-validated" : ""}`}
                                          onSubmit={formik.handleSubmit} noValidate={true}>

                                        <Input
                                            type="text"
                                            className="text-start"
                                            dir="ltr"
                                            name="mobile"
                                            placeholder="تلفن همراه خود را وارد نمایید"
                                            label="موبایل"
                                            formik={formik}
                                            value={convertToWesternNumerals(formik.values.mobile)} // Use formik.values directly
                                            onChange={(e) => {
                                                const convertedValue = convertToWesternNumerals(e.target.value);
                                                formik.handleChange(e);
                                                formik.setFieldValue('mobile', convertedValue);
                                            }}
                                            icon={'bx-mobile'}

                                        />


                                        <button className="btn btn-primary d-grid w-100"
                                                disabled={!formik.isValid}>دریافت کد
                                        </button>
                                    </form>

                                    <p className="text-center">
                                        <span>حساب کاربری دارید؟</span><span>&nbsp;</span>
                                        <Link to="/login">
                                            <span>وارد شوید</span>
                                        </Link>
                                    </p>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            { showValidationCode == 1 &&
                <div className="container-xxl backgroud-image">
                    <div className="authentication-wrapper authentication-basic container-p-y">
                        <div className="authentication-inner py-4">
                            <div className="card card-border">
                                <div className="card-body">
                                    <div className="col-5 app-brand justify-content-center m-auto">
                                        {/*<img src="/logo.png" className={'w-100 '}/>*/}
                                    </div>
                                    <hr/>


                                    <p className="mb-2 text-center">کد پیامک شده به {mobile} را وارد نمایید</p>
                                    <div
                                        className={`needs-validation mb-3 text-center `}
                                    >
                                        <div className="mb-3 ">
                                            <VerifyCode  length={4} onCodeChange={handleCodeChange} />
                                        </div>

                                        <button className="btn btn-primary d-grid w-100 " type={"button"} onClick={onConfirmChangePasswordCodeSubmit }>تایید کد
                                        </button>
                                    </div>

                                    <p className="text-center">

                                        <Link onClick={()=>showValidationCode(false)}>
                                            <span>ویرایش تلفن همراه</span>
                                        </Link>
                                    </p>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {showValidationCode == 2 &&
                <div className="container-xxl backgroud-image">
                    <div className="authentication-wrapper authentication-basic container-p-y">
                        <div className="authentication-inner py-4">
                            <div className="card card-border">
                                <div className="card-body">
                                    <div className="col-5 app-brand justify-content-center m-auto">
                                        {/*<img src="/logo.png" className={'w-100 '}/>*/}
                                    </div>
                                    <hr/>

                                    <h4 className="mb-2 text-center">رمز جدید خود را وارد نمایید</h4>
                                    {/*<p className="mb-4">مدیریت برنامه خود را آسان و جذاب کنید!</p>*/}

                                    <form id="formAuthentication"
                                          className={`needs-validation mb-3 ${!formikChangePassword.isValid ? "was-validated" : ""}`}
                                          onSubmit={formikChangePassword.handleSubmit} noValidate={true}>

                                        <InputPassword
                                            label="رمز عبور"
                                            className="text-start"
                                            dir="ltr"
                                            name="password"
                                            placeholder="············"
                                            formik={formikChangePassword}
                                            value={convertToWesternNumerals(formikChangePassword.values.password) } // Use formik.values directly
                                            onChange={(e) => {
                                                const convertedValue = convertToWesternNumerals(e.target.value);
                                                formikChangePassword.handleChange(e);
                                                formikChangePassword.setFieldValue('password', convertedValue);
                                            }}
                                        />
                                        <InputPassword
                                            label="تکرار رمز عبور"
                                            className="text-start"
                                            dir="ltr"
                                            name="confirmPassword"
                                            placeholder="············"
                                            formik={formikChangePassword}
                                            value={convertToWesternNumerals(formikChangePassword.values.confirmPassword) } // Use formik.values directly
                                            onChange={(e) => {
                                                const convertedValue = convertToWesternNumerals(e.target.value);
                                                formikChangePassword.handleChange(e);
                                                formikChangePassword.setFieldValue('confirmPassword', convertedValue);
                                            }}
                                        />


                                        <button className="btn btn-primary d-grid w-100"
                                                disabled={!formikChangePassword.isValid}>تغییر رمز عبور
                                        </button>
                                    </form>

                                    <p className="text-center">
                                        <span>حساب کاربری دارید؟</span><span>&nbsp;</span>
                                        <Link to="/login">
                                            <span>وارد شوید</span>
                                        </Link>
                                    </p>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                isLoading ? (<Loading/>) : null
            }
            <Modal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                size="xl"
                modalTitle={" کاربر را انتخاب نمایید"}
            >
                <div className={"row"}>
                    <div className="col-xl-12">

                        {referencerList?.map((item) => (
                            <>
                                <button className={`btn btn-primary me-3 text-center ms-auto w-100 mb-1 bg-success`} type={"button"} onClick={()=>handelSelectReferencer(item.id)} > {item.name} </button>

                            </>
                        ))
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}